<template>
    <div class="bg-white text-black pt-28 pb-20 md:pb-28" :class="$device.isDesktop ? 'lg:pt-52' : 'lg:pt-40'">
        <div class="container">
            <div class="grid grid-cols-12 gap-5">
                <div class="col-span-12 lg:col-span-8 lg:col-start-3">
                    <h1 class="title title-xl mb-8">{{ model.title }}</h1>
                    <span class="block mb-16">
                        {{ $t('generic.last_updated') }}: {{ $dayjs(model.updated_at * 1000).format('YYYY. MM. DD') }}
                    </span>
                    <section v-html="model.body"></section>
                    <SectionDownloadables v-if="model.downloads" :attachments="model.downloads" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SectionDownloadables from '@/components/Sections/SectionDownloadables/SectionDownloadables';

export default {
    name: 'SiteContentPageWrapper',
    components: {
        SectionDownloadables,
    },
    props: {
        model: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped></style>
